export function ChevronDownIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M8 10.4667L4 6.46666L4.93333 5.53333L8 8.59999L11.0667 5.53333L12 6.46666L8 10.4667Z" />
    </svg>
  );
}

export function StarIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M4.91246 12.75L5.72496 9.2375L2.99996 6.875L6.59996 6.5625L7.99996 3.25L9.39996 6.5625L13 6.875L10.275 9.2375L11.0875 12.75L7.99996 10.8875L4.91246 12.75Z" />
    </svg>
  );
}

export function StarSelectedIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M12.5858 11.5899L11.1065 10.1106L11.7969 9.42025L13.2761 10.8995L12.5858 11.5899ZM10.8107 5.67272L10.1203 4.98238L11.5996 3.50309L12.29 4.19343L10.8107 5.67272ZM5.18936 5.67272L3.71007 4.19343L4.40041 3.50309L5.8797 4.98238L5.18936 5.67272ZM3.41421 11.5899L2.72388 10.8995L4.20317 9.42025L4.8935 10.1106L3.41421 11.5899Z" />
      <path d="M4.95514 12.724L5.75642 9.26L3.06904 6.93011L6.61934 6.62193L8.00001 3.35516L9.38068 6.62193L12.931 6.93011L10.2436 9.26L11.0449 12.724L8.00001 10.8872L4.95514 12.724Z" />
    </svg>
  );
}

export function ArrowIcon({ direction = "end" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      aria-hidden="true"
      style={direction === "start" ? { transform: "scaleX(-1)" } : undefined}
    >
      <path d="M10.7833 8.66666H2.66667V7.33332H10.7833L7.05 3.59999L8 2.66666L13.3333 7.99999L8 13.3333L7.05 12.4L10.7833 8.66666Z" />
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M4.26667 12.6666L3.33333 11.7333L7.06667 7.99998L3.33333 4.26665L4.26667 3.33331L8 7.06665L11.7333 3.33331L12.6667 4.26665L8.93333 7.99998L12.6667 11.7333L11.7333 12.6666L8 8.93331L4.26667 12.6666Z" />
    </svg>
  );
}

export function CheckmarkIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M6.19793 12.4224L2.00537 8.22985L3.05351 7.18171L6.19793 10.3261L12.9465 3.57758L13.9946 4.62572L6.19793 12.4224Z" />
    </svg>
  );
}

export function InfoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M7.33333 11.3333H8.66667V7.33334H7.33333V11.3333ZM8.475 5.80834C8.60278 5.68057 8.66667 5.52223 8.66667 5.33334C8.66667 5.14445 8.60278 4.98612 8.475 4.85834C8.34722 4.73057 8.18889 4.66668 8 4.66668C7.81111 4.66668 7.65278 4.73057 7.525 4.85834C7.39722 4.98612 7.33333 5.14445 7.33333 5.33334C7.33333 5.52223 7.39722 5.68057 7.525 5.80834C7.65278 5.93612 7.81111 6.00001 8 6.00001C8.18889 6.00001 8.34722 5.93612 8.475 5.80834ZM8 14.6667C7.07778 14.6667 6.21111 14.4917 5.4 14.1417C4.58889 13.7917 3.88333 13.3167 3.28333 12.7167C2.68333 12.1167 2.20833 11.4111 1.85833 10.6C1.50833 9.7889 1.33333 8.92223 1.33333 8.00001C1.33333 7.07779 1.50833 6.21112 1.85833 5.40001C2.20833 4.5889 2.68333 3.88334 3.28333 3.28334C3.88333 2.68334 4.58889 2.20834 5.4 1.85834C6.21111 1.50834 7.07778 1.33334 8 1.33334C8.92222 1.33334 9.78889 1.50834 10.6 1.85834C11.4111 2.20834 12.1167 2.68334 12.7167 3.28334C13.3167 3.88334 13.7917 4.5889 14.1417 5.40001C14.4917 6.21112 14.6667 7.07779 14.6667 8.00001C14.6667 8.92223 14.4917 9.7889 14.1417 10.6C13.7917 11.4111 13.3167 12.1167 12.7167 12.7167C12.1167 13.3167 11.4111 13.7917 10.6 14.1417C9.78889 14.4917 8.92222 14.6667 8 14.6667ZM8 13.3333C9.48889 13.3333 10.75 12.8167 11.7833 11.7833C12.8167 10.75 13.3333 9.4889 13.3333 8.00001C13.3333 6.51112 12.8167 5.25001 11.7833 4.21668C10.75 3.18334 9.48889 2.66668 8 2.66668C6.51111 2.66668 5.25 3.18334 4.21667 4.21668C3.18333 5.25001 2.66667 6.51112 2.66667 8.00001C2.66667 9.4889 3.18333 10.75 4.21667 11.7833C5.25 12.8167 6.51111 13.3333 8 13.3333Z" />
    </svg>
  );
}
